<template>
    <div class="ui-content dashboard">
        <div class="page-user approved">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab :href="'#Student'">Student</v-tab>
                <v-tabs-items :touchless="true" v-model="tab">
                    <v-tab-item :value="'Student'">
                        <v-card class="mx-auto normal-card">
                            <BatchAllocationStudent :updateRouteDetails="updateRouteDetails"  />
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import BatchAllocationStudent from "@/components/coordinator/users/BatchAllocation/BatchAllocationStudent.vue";
export default {
    name: "BatchAllocation",
    components: {
        BatchAllocationStudent
    },
    data() {
        return {
            tab: null,
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tabs: 1
        };
    },
    mounted() {
        this.defaultData();
        this.checkSessionData();
    },
    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        updateRouteDetails(details) {
            let routeName = this.$route.name;            
            let crd = this.getCurrentRouteDetails(routeName);           
            switch (details.type) {
                case 'centerIds':
                    crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;                                                            
                    break;            
                case 'batchIds':
                    crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;                                                            
                    break;            
                default:
                    break;
            }
            this.setRouteDetails(crd)
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName); 
            if(crd) {
                this.tab = crd.selectedTab ? crd.selectedTab : 'Student';
            }
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            
            if(rp.params.resetPage || !crd.routeName) {
                let tabDetail = {
                    Student: {page: 1, showActivated: 1, centerIds: [], batchIds: [], 
                        orderBy: {
                            field: "name",
                            order: "ASC"
                        } 
                    },
                };
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                    tabDetails: tabDetail,
                }
                this.setRouteDetails(routeDetails);
            }
        },
    },
    watch: {
        tab(val, oldVal) {
            if(oldVal) { // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({routeName, selectedTab: val});
            }
            this.addBreadCrumbChilde([
                {
                    text: val,
                    disabled: false
                }
            ]);
        }
    }
};
</script>